export class SummaryTableEntry {
    objectMapped: object;
    constructor(public key: string, public value: number) { }
}
